import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import CreateClassInProgramForm from "../Forms/CreateClassInProgramForm";
import ImportStudentsForm from "../Forms/ImportStudentsForm";
import { FormattedMessage } from "react-intl";

export default function CreateClassInProgram(props) {
  const [importStudentStage, setImportStudentStage] = useState(false);
  const [createdClass, setCreatedClass] = useState(null);
  const moveToNextStep = (createdClass) => {
    setCreatedClass(createdClass);
    setImportStudentStage(true);
  };

  const toggleModal = () => {
    setImportStudentStage(false);
    props.toggle();
  };

  return (
    <Modal
      style={{ maxWidth: "700px", width: "80%" }}
      isOpen={props.isOpen}
      toggle={props.toggle}
    >
      <ModalHeader>
        <FormattedMessage id="CreateClass" />
      </ModalHeader>
      <ModalBody>
        {!importStudentStage ? (
          <CreateClassInProgramForm
            teachers={props.teachers}
            school={props.school}
            toggleModal={toggleModal}
            handleAddedClass={props.handleAddedClass}
            reloadData={props.reloadData}
            program={props.program}
            orientations={props.orientations}
            purchaser={props.purchaser}
            fullAccess={props.fullAccess}
            moveToNextStep={moveToNextStep}
            addStudentsAfterCreatingClass={
              props.addStudentsAfterCreatingClass
                ? props.addStudentsAfterCreatingClass
                : false
            }
            newTeachersToAdd={props.newTeachersToAdd}
            setNewTeachersToAdd={props.setNewTeachersToAdd}
          />
        ) : (
          <ImportStudentsForm
            preSelectedClass={true}
            preSelectedClassId={createdClass.id}
            updateStudents={props.reloadClass}
            dismissModal={toggleModal}
            studentClasses={createdClass}
          />
        )}
      </ModalBody>
    </Modal>
  );
}
